//header.js is the header for all other pages except the homepage in desktop view. Social icons are still inclued in the header.js beacause they
//are displayed in the top nav on mobile for every page.

import React from 'react';
import { Link } from 'gatsby';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTwitterSquare,
  faLinkedin,
  faYoutubeSquare,
} from '@fortawesome/free-brands-svg-icons';
import ScrollAnimation from 'react-animate-on-scroll';
import Logo from './logo';
import HeaderStyle from './header.module.scss';

// The following import prevents a Font Awesome icon server-side rendering bug,
// where the icons flash from a very large icon down to a properly sized one:
import '@fortawesome/fontawesome-svg-core/styles.css';
// Prevent fontawesome from adding its CSS since we did it manually above:
import { config } from '@fortawesome/fontawesome-svg-core';
config.autoAddCss = false; /* eslint-disable import/first */

const Header = () => (
  <Navbar className={HeaderStyle.navbar}>
    <Navbar.Brand>
      <Link to='/'>
        <Logo />
      </Link>
    </Navbar.Brand>
    <Nav className='ml-auto'>
      <div className={HeaderStyle.navItemDiv}>
        <NavDropdown
          className={HeaderStyle.dropdownToggle}
          title='Website Features'
          id='basic-nav-dropdown'
        >
          <ScrollAnimation
            animateIn='fadeInDown'
            duration={2}
            animateOnce={true}
          >
            <Link className={HeaderStyle.navDropdownLink} to='/essentials'>
              The Essentials
            </Link>
            <Link className={HeaderStyle.navDropdownLink} to='/mobile-first'>
              Mobile First
            </Link>
            <Link className={HeaderStyle.navDropdownLink} to='/engaging-menu'>
              Engaging Menu
            </Link>
            <Link
              className={HeaderStyle.navDropdownLink}
              to='/convenient-booking'
            >
              Convenient Booking
            </Link>
          </ScrollAnimation>
        </NavDropdown>
        <Link
          className={HeaderStyle.navLink}
          to='/pricing'
          data-testid='pricingpage'
        >
          Pricing
        </Link>
        <Link className={HeaderStyle.navLink} to='/templates'>
          Templates
        </Link>
        <Link className={HeaderStyle.navLink} to='/our-story'>
          Our Story
        </Link>
      </div>
      <div className={HeaderStyle.navSocialDiv}>
        <Nav.Link
          href='https://www.linkedin.com/company/first-string-digital/'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FontAwesomeIcon icon={faLinkedin} className={HeaderStyle.navIcon} />
        </Nav.Link>
        <Nav.Link
          href='https://www.twitter.com/weareFSDigital'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FontAwesomeIcon
            icon={faTwitterSquare}
            className={HeaderStyle.navIcon}
          />
        </Nav.Link>
        <Nav.Link
          href='https://www.youtube.com/channel/UCIuR10cXn6xTdCQhDgN-cIA'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FontAwesomeIcon
            icon={faYoutubeSquare}
            className={HeaderStyle.navIcon}
          />
        </Nav.Link>
      </div>
    </Nav>
  </Navbar>
);

export default Header;
